import eventBus, { EventTypes } from 'utils/helpers/eventBus';

function toggleWorkspaceMenu(state: boolean): void {
  eventBus.emit(EventTypes.TOGGLE_WORKSPACE_MENU, state);
}

export default toggleWorkspaceMenu;
